import { definition } from "@fortawesome/free-solid-svg-icons/fa0";

export const products = [
  {
    id: "course1",
    image: "/AboutUs3.png",
    title: "Vertical Farming",
    duration: "2 hours",
  },
  {
    id: "course2",
    image: "/HydroFarming.png",
    title: "Hydro Farming ",
    duration: "2 hours",
  },
  {
    id: "course3",
    image: "/Crop rotation.png",
    title: "Crop Rotation",
    duration: "1 - 3 Months",
  },
  {
    id: "course4",
    image: "/soil conservation.png",
    title: "Soil Conservation",
    duration: "1 - 3 Months",
  },
  {
    id: "course5",
    image: "/water management.png",
    title: "Water Management",
    duration: "1 - 3 Months",
  },
];

export const communityDetails = [
  {
    image: "/AboutUs3.png",
    title: "Vertical Farming",
    about: "Vegetable",
    green: "Tomato",
    popupPage: "TomatoVerticalPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Vegetables</span>
        <span style={{ color: "#257830" }}> Vertical Farming</span> Community
      </>
    ),
  },
  {
    image: "/FrameHome.png",
    title: "Vertical Farming",
    about: "Vegetable",
    green: "Lettuce",
    popupPage: "LettuceVerticalPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Lettuce</span>
        <span style={{ color: "#257830" }}> Vertical Farming</span> Community
      </>
    ),
  },
  {
    image: "/Grain vertical.png",
    title: "Vertical Farming",
    about: "Grain",
    green: "Rice",
    popupPage: "GrainVerticalPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Grain</span>
        <span style={{ color: "#257830" }}> Vertical Farming</span> Community
      </>
    ),
  },
  {
    image: "/tuber verticall 1.png",
    title: "Vertical Farming",
    about: "Tuber",
    green: "Potato",
    popupPage: "PotatoVerticalPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Tuber</span>
        <span style={{ color: "#257830" }}> Vertical Farming</span> Community
      </>
    ),
  },
  {
    image: "/hydroponic vegetable 1 1.png",
    title: "Hydro Farming",
    about: "Vegetable",
    green: "Tomato",
    popupPage: "TomatoHydroPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Vegetables</span>
        <span style={{ color: "#257830" }}> Hydro Farming</span> Community
      </>
    ),
  },
  {
    image: "/hydro vegetable 3 1.png",
    title: "Hydro Farming",
    about: "Vegetable",
    green: "Lettuce",
    popupPage: "LettuceHydroPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Lettuce</span>
        <span style={{ color: "#257830" }}> Hydro Farming</span> Community
      </>
    ),
  },
  {
    image: "/hydroponic 1 1.png",
    title: "Hydro Farming",
    about: "Grain",
    green: "Tomato",
    popupPage: "GrainHydroPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Grain</span>
        <span style={{ color: "#257830" }}> Hydro Farming</span> Community
      </>
    ),
  },
  {
    image: "/hydroponic 1 1.png",
    title: "Hydro Farming",
    about: "Tuber",
    green: "Rice",
    popupPage: "TuberHydroPopup",
    paragraph: (
      <>
        You have successfully joined
        <span style={{ color: "#f29620" }}> Tuber</span>
        <span style={{ color: "#257830" }}> Hydro Farming</span> Community
      </>
    ),
  },
];
export const courseDetails = [
  {
    id: "1",
    lesson: "Lesson 1",
    title: "Meaning of Vertical Farming",
    period: "5 Mins",
    lessonTitle: "Vertical Farming",
    lessonTopic: (
      <span style={{ color: "#226D2C" }}>What is Vertical Farming?</span>
    ),
    lessonParagraph: (
      <>
        <span style={{ color: "#226D2C" }}>Vertical farming</span> is an
        innovative technique that involves growing crops in vertically stacked
        layers, often in controlled environments like indoor facilities,
        warehouses, or high-rise buildings. Unlike conventional horizontal
        farming that heavily relies on vast tracts of land, vertical farming
        makes efficient use of space by utilizing height.
      </>
    ),
    img: "/FrameHome.png",
  },
  {
    id: "2",
    lesson: "Lesson 2",
    title: "Key Features of Vertical Farming",
    period: "10 Mins",
    lessonTitle: "Key features of Vertical Farming",
    lessonTopic:
      "Vertical farming is a modern agricultural technique that has several key features. Some of them are:",
    lessonParagraph: (
      <>
        <p>
          1.{" "}
          <span style={{ color: "#226D2C", paddingBottom: "10px" }}>
            Vertical Growing Structures:
          </span>{" "}
          crops are cultivated in vertically stacked layers using shelves,
          racks, or towers. This method allows for high-density planting and
          optimal use of available space.{" "}
        </p>
        <br />
        <p>
          2. <span style={{ color: "#226D2C" }}>Controlled Environment:</span>{" "}
          vertical farming facilities are equipped with climate control systems
          that carefully monitor and optimize temperature, humidity, light, and
          nutrient levels for plant growth. This control minimizes the impact of
          external factors such as weather and pests, resulting in consistent
          and predictable crop yields.
        </p>
        <br />
        <p>
          3.{" "}
          <span style={{ color: "#226D2C" }}>
            Hydroponic or Aeroponic Systems:
          </span>{" "}
          many vertical farms use hydroponic or aeroponic systems for soilless
          cultivation. In hydroponics, plants are grown in nutrient-rich water
          solutions, while in aeroponics, plants are misted with nutrient-rich
          air. These systems provide plants with essential nutrients, while
          minimizing water usage and eliminating the need for soil.
        </p>
        <br />
        <p>
          4. <span style={{ color: "#226D2C" }}>Artificial Lighting:</span> as
          natural sunlight may be limited in indoor environments, artificial
          lighting systems such as LED grow lights are used to provide the
          necessary light spectrum for photosynthesis. These lighting systems
          can be tailored to the specific needs of different crops and growth
          stages.
        </p>
        <br />
        <p>
          5.<span style={{ color: "#226D2C" }}>Urban Agriculture:</span>{" "}
          vertical farming, is highly suitable for urban areas with limited land
          availability and high demand for locally grown produce. Vertical farms
          help to bring food production closer to consumers, reducing
          transportation costs and carbon emissions associated with traditional
          agriculture.
        </p>
      </>
    ),
  },
  {
    id: "3",
    lesson: "Lesson 3",
    title: "Methods of Pre-Planting Vegetables Using Vertical Farming",
    period: "5 Mins",
    lessonTopic: "VEGETABLES",
    lessonDefinition:
      "Vertical farming offers unique opportunities for growing vegetables efficiently in controlled environments. Here's a breakdown of pre-planting, planting, and post-planting methods specific to vertical farming:",
    subTitle: (
      <>
        <span style={{ color: "#F29620" }}>Pre-Planting Methods</span>
      </>
    ),
    lessonParagraph: (
      <>
        <p>
          1. <span style={{ color: "#226D2C" }}>Crop Selection:</span> Choose
          vegetable crops that are well-suited for vertical farming, considering
          factors such as growth habit, light requirements, and space
          efficiency. Leafy greens like lettuce, herbs like basil, and compact
          varieties of tomatoes and cucumbers are popular choices.{" "}
        </p>
        <br />
        <p>
          2. <span style={{ color: "#226D2C" }}>Facility Design: </span> Design
          the vertical farming facility to maximize space utilization and
          optimize environmental conditions. This includes selecting appropriate
          shelving or tower systems, installing climate control systems for
          temperature and humidity regulation, and implementing efficient
          lighting solutions.
        </p>
        <br />
        <p>
          3. <span style={{ color: "#226D2C" }}>Substrate Preparation:</span>{" "}
          Depending on the cultivation method (e.g., hydroponics, aeroponics),
          prepare the growing substrate or medium. For hydroponic systems, this
          may involve setting up nutrient reservoirs and circulating systems.
          For aeroponic systems, ensure proper misting equipment and nutrient
          delivery systems are in place.
        </p>
      </>
    ),
  },
  {
    id: "4",
    lesson: "Lesson 4",
    title: "Methods of Planting Vegetables Using Vertical Farming",
    period: "5 Mins",
    lessonTitle: (
      <>
        <span style={{ color: "#F29620" }}>Planting Methods</span>
      </>
    ),
    lessonParagraph: (
      <>
        <p>
          1. <span style={{ color: "#226D2C" }}>Seedling Production:</span>
          Start with high-quality seeds or seedlings suited to vertical farming
          conditions. Use seedling trays or propagation systems to germinate
          seeds and grow healthy seedlings before transplanting them into the
          vertical farming system.{" "}
        </p>
        <br />
        <p>
          2. <span style={{ color: "#226D2C" }}>Transplanting: </span>
          Once seedlings are ready, transplant them into the vertical growing
          system according to the specific layout and spacing requirements.
          Ensure proper spacing between plants to prevent overcrowding and allow
          for adequate air circulation and light penetration.
        </p>
        <br />
        <p>
          3. <span style={{ color: "#226D2C" }}>Vertical Arrangement:</span>
          Arrange plants vertically on shelves, racks, or towers, taking
          advantage of available space. Consider factors such as plant height,
          growth rate, and light requirements when positioning plants within the
          vertical structure.
        </p>
      </>
    ),
  },
  {
    id: "5",
    lesson: "Lesson 5",
    title: "Methods of Post-Planting Vegetables Using Vertical Farming",
    period: "10 Mins",
    lessonTitle: (
      <>
        <span style={{ color: "#F29620" }}>Post-Planting Methods</span>
      </>
    ),
    lessonParagraph: (
      <>
        <p>
          1. <span style={{ color: "#226D2C" }}>Nutrient Management:</span>
          Monitor and maintain nutrient levels in hydroponic or aeroponic
          systems to ensure optimal plant nutrition. Regularly test nutrient
          solutions and adjust as needed to meet the requirements of different
          vegetable crops at various growth stages.{" "}
        </p>
        <br />
        <p>
          2. <span style={{ color: "#226D2C" }}>Watering and Irrigation: </span>
          Implement efficient watering and irrigation systems to deliver water
          and nutrients to plants while minimizing waste. Automated irrigation
          systems with timers or sensors can help ensure consistent moisture
          levels and prevent overwatering or underwatering.
        </p>
        <br />
        <p>
          3. <span style={{ color: "#226D2C" }}>Pruning and Training:</span>
          Regularly prune and train vegetable plants to promote healthy growth
          and maximize productivity. Remove damaged or diseased foliage, and use
          trellising or support structures to guide plant growth vertically and
          prevent sprawling.
        </p>
      </>
    ),
  },
  {
    id: "6",
    lesson: "Quiz",
    title: "Quiz",
    period: "10 Mins",
  },
  {
    id: "lesson 7",
    lesson: "Lesson 6",
    title: "Methods of Pre-Planting Grains Using Vertical Farming",
    period: "5 Mins",
  },
  {
    id: "lesson 8",
    lesson: "Lesson 7",
    title: "Methods of Planting Grains Using Vertical Farming",
    period: "5 Mins",
  },
  {
    id: "lesson 9",
    lesson: "Lesson 8",
    title: "Methods of Post-Planting Grains Using Vertical Farming",
    period: "10 Mins",
  },
  {
    id: "lesson 8",
    lesson: "Lesson 9",
    title: "Methods of Pre-Planting Tuber Using Vertical Farming",
    period: "5 Mins",
  },
  {
    id: "lesson 9",
    lesson: "Lesson 10",
    title: "Methods of Planting Tuber Using Vertical Farming",
    period: "5 Mins",
  },
  {
    id: "lesson 10",
    lesson: "Lesson 11",
    title: "Methods of post-Planting Tuber Using Vertical Farming",
    period: "10 Mins",
  },
  {
    id: "lesson 11",
    lesson: "Quiz 2",
    title: "Quiz 2",
    period: "10 Mins",
  },
  {
    id: "lesson 12",
    lesson: "Exam",
    title: "Exam",
    period: "20 Mins",
  },
];
